import React from 'react';

const HasPermissions = (props) => {
  const menu = Object.keys(JSON.parse(sessionStorage.getItem("menu")))
  if (menu.includes(props.role))
    return props.children
  else
    return <div>
      This user do not have permissions for {props.name}
    </div>
};

export default HasPermissions;